import {Moment} from "moment";
import {ApolloError, useMutation} from "@apollo/client";
import {UpdateGameMutation} from "../gql/mutations";


export const useUpdateGameMutation = (gameId: string)
  : [Function, { loading: boolean, error: ApolloError | undefined }] => {
  const [update, {loading, error}] = useMutation(UpdateGameMutation)
  const updateGame = (round: number, dateStart: Moment) => {
    update({
      variables: {
        id: gameId,
        round,
        dateStart: dateStart.toISOString()
      }
    })
  }

  return [updateGame, {loading, error}]

}